<div class="page-layout carded fullwidth inner-scroll data-list">
    <mat-toolbar matDialogTitle class="accent-600 m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Múltiplos Procedimentos</div>
            <button mat-icon-button (click)="dimiss('N')" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-12" fusePerfectScrollbar style="min-height: 300px;">
        <div fxLayout="row" *ngIf="details">
            <table mat-table fxFlex="100" [dataSource]="scheduleOrderList" >

            <!-- Position Column -->
            <ng-container matColumnDef="procedure" fxFlex="50">
                <th mat-header-cell *matHeaderCellDef> Procedimento</th>
                <td mat-cell *matCellDef="let element"> <p class="text-truncate">{{element?.procedure?.alias}}</p> </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="element.orderId > 0" (click)="confirmNavigateOrder('print',element.scheduleId, element.orderId)" mat-button class="mat-accent mr-16" >
                        <p>Imprimir Guia</p>
                    </button>
                    <button *ngIf="element.orderId == 0 && !noOs" mat-button class="mat-accent mr-16"  (click)="confirmNavigateOrder('new',element.scheduleId, null)">
                        <p>Lançar Atendimento</p>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        </div>
        <div fxLayout="row" *ngIf="!details">
            <mat-list style="padding-top: 0px !important;">
                <div mat-header style="margin-top: 0px !important;"><b><h2>{{'Esse Agendamento possui outros procedimentos :'}}</h2></b> </div>
                <mat-list-item  style="height: auto !important;">
                    <div mat-line style="font-size: 0.8em;" *ngFor="let prod of procedureList">{{ prod?.procedure?.alias  || prod?.alias}}

                    </div>
                </mat-list-item>
            </mat-list>
        </div>
    </div>

    <div mat-dialog-actions class=" m-0 p-16" fxLayout="row" fxLayoutAlign="end end" *ngIf="!details">
        <button [disabled]="loadingButton" mat-raised-button (click)="dimiss('S')"  class="mr-12">
            Lançar em OS separadas
        </button>
        <button [disabled]="loadingButton" mat-raised-button (click)="dimiss('M')"  class="mr-12">
            Lançar na mesma OS
        </button>
        <button [disabled]="loadingButton" mat-raised-button (click)="dimiss('N')" >
            Continuar
        </button>
    </div>
    <div mat-dialog-actions class=" m-0 p-16" fxLayout="row" fxLayoutGap="10" fxLayoutAlign="end end" *ngIf="details">
        <button mat-raised-button class="mat-accent" (click)="confirmNavigateOrder('list',null, null )">
            Ir para listagem
        </button>
        <button mat-raised-button class="mat-accent" *ngIf="noOs" (click)="confirmNavigateOrder('new',schedule.id, null )">
           Lançar atendimento
        </button>
        <button mat-raised-button (click)="dimiss('N')" >
            Cancelar
        </button>
    </div>
</div>
